import PropTypes from 'prop-types';
import { Display, Text } from '@/components/ui/index.js';
import styles from './StatItem.module.css';

/**
 * StatItem - Large stat display with neon glow
 * Shows a number and label with animated reveal
 */
export function StatItem({ value, label, delay = 0, color = 'cyan' }) {
  return (
    <article
      className={styles.stat}
      style={{ animationDelay: `${delay}ms` }}
    >
      <Display
        as="span"
        size="lg"
        weight="black"
        align="center"
        className={`${styles.value} ${styles[color]}`}
      >
        {value}
      </Display>
      <Text size="sm" color="secondary" align="center" className={styles.label}>
        {label}
      </Text>
      <div className={`${styles.glow} ${styles[`glow${color}`]}`} />
    </article>
  );
}

StatItem.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  delay: PropTypes.number,
  color: PropTypes.oneOf(['cyan', 'lime']),
};

export default StatItem;
